<markant-platform-ui-card
  class="management-tile"
  [headline]="'cartridge.management.cancellation.title' | transloco"
>
  <p class="actions-section-text">
    {{ 'cartridge.management.cancellation.info' | transloco }}
  </p>
  <div footer>
    <a class="link" (click)="openCancelProcessDialog(serviceId)">
      {{ 'common.details' | transloco }}
      <markant-icon class="link-icon" icon="m_arrow-right-small"></markant-icon>
    </a>
  </div>
</markant-platform-ui-card>
<markant-platform-cancel-process
  *ngIf="isCancelProcessDialogOpen"
  [bookingId]="bookingId"
  (closed)="closeDialog()"
></markant-platform-cancel-process>
